import React, { ReactElement } from 'react'; 
import {AppBar, Tabs, Tab, Box} from '@material-ui/core';
import PRO_TIP_ICON from '../../../assets/pro-tip-process.svg';
import STATIC_TEXT from '../../../content/common.json';
import { useDocumentRequirementsStyles } from './document-requirements.styles';
import { usePopoverTooltipElementStyles } from '../../portico/tooltip/popover-tooltip.styles';
import Spacing from '../../portico/spacing/spacing';
import { PopoverTooltip } from '../../portico/tooltip/tooltip';
import { WelcomeBodyWrapper } from '../welcome-body-wrapper';
import { WelcomeFooterWrapper } from '../welcome-footer-wrapper';
import { CompanyDocumentRequirements } from './company-document-requirements';
import { IndividualDocumentRequirements } from './individual-document-requirements'; ;

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function a11yProps(index: number): object {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}

function TabPanel(props: TabPanelProps): JSX.Element {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

export const DocumentRequirements: React.FC = (): JSX.Element => {
  const classes = useDocumentRequirementsStyles(); 
  const [value, setValue] = React.useState(0);
  const popoverTooltipElementStyles = usePopoverTooltipElementStyles(); 
  
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number): void => {
    event.preventDefault();
    setValue(newValue);
  };

  const getPatriotLabel = (): ReactElement => (
    <>
      {STATIC_TEXT.welcome.docs.description1}

      <PopoverTooltip
        messageDescription={STATIC_TEXT.welcome.docs.patriotDescription}
      >
        <span className={popoverTooltipElementStyles.popoverTooltipElement}>
          {STATIC_TEXT.welcome.docs.descriptionTooltip}
        </span>
      </PopoverTooltip>
      {STATIC_TEXT.welcome.docs.description2}
    </>
  );

  return (
    <>
      <WelcomeBodyWrapper
        activeStep={3}
        totalSteps={3}
        title={STATIC_TEXT.welcome.docs.title}
        subTitle={STATIC_TEXT.welcome.docs.description}
      >
        <div className={classes.root}>
          <AppBar position="static" color="default" className={classes.tabStyles}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              <Tab label={STATIC_TEXT.welcome.docs.companyDocuments} {...a11yProps(0)} />
              <Tab label={STATIC_TEXT.welcome.docs.personalInformation} {...a11yProps(1)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <CompanyDocumentRequirements/>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <IndividualDocumentRequirements/>
          </TabPanel>
        </div>
      </WelcomeBodyWrapper>

      <Spacing variable="spacing-base-x9" />

      <WelcomeFooterWrapper
        className="footer__content_doc"
        proTipIcon={PRO_TIP_ICON}
        proTipLabel={STATIC_TEXT.welcome.docs.proTipLabel}
        proTipDescription={getPatriotLabel()}
        buttonLabel={STATIC_TEXT.welcome.navigationButton.next_start_app}
      />
    </>
  );
};